import {useEffect, useRef, useState} from 'react';
import {Button} from '../ui';

/** Query-free single-row collection. Items, visibility and destinations belong to the caller. */
export default function CompetitionCarousel({id, label, heading, description, actions, items, renderCard, empty,
  previousLabel = 'Previous competitions', nextLabel = 'Next competitions'}) {
  const rail = useRef(null);
  const [edges,setEdges] = useState({start:true,end:true});
  const update = () => {
    const node=rail.current;
    if(node)setEdges({start:node.scrollLeft<2,end:node.scrollLeft+node.clientWidth>=node.scrollWidth-2});
  };
  useEffect(()=>{
    update();const node=rail.current;if(!node)return;
    const observer=new ResizeObserver(update);observer.observe(node);
    return ()=>observer.disconnect();
  },[items.length]);
  const scroll = direction => {
    const node=rail.current;
    if(node)node.scrollBy({left:direction*Math.max(260,node.clientWidth*.8),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  };
  return <section className="dashboard-section" aria-labelledby={`${id}-title`}>
    <div className="dashboard-section-heading"><div><h2 id={`${id}-title`}>{heading}</h2>{description&&<p className="text-content-secondary text-sm">{description}</p>}</div>
      <div className="dashboard-discovery-tools">{actions}{items.length>0&&<div className="dashboard-carousel-controls">
        <Button variant="secondary" aria-label={previousLabel} aria-controls={id} disabled={edges.start} onClick={()=>scroll(-1)}>←</Button>
        <Button variant="secondary" aria-label={nextLabel} aria-controls={id} disabled={edges.end} onClick={()=>scroll(1)}>→</Button>
      </div>}</div>
    </div>
    {!items.length ? empty : <>
      <p id={`${id}-help`} className="sr-only">Scroll horizontally or use the previous and next buttons. Use left and right arrow keys while the competition row is focused. Home and End jump to either end.</p>
      <div id={id} className="dashboard-carousel" role="region" aria-label={label} aria-describedby={`${id}-help`} tabIndex={0} ref={rail} onScroll={update} onKeyDown={event=>{
        if(event.target!==event.currentTarget)return;
        if(['ArrowLeft','ArrowRight','Home','End'].includes(event.key)){
          event.preventDefault();
          if(event.key==='Home'||event.key==='End')rail.current.scrollTo({left:event.key==='Home'?0:rail.current.scrollWidth});
          else scroll(event.key==='ArrowRight'?1:-1);
        }
      }}>{items.map(item=><div className="dashboard-carousel-item" key={item.id}>{renderCard(item)}</div>)}</div>
    </>}
  </section>;
}
